// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__6wtzX","content":"LoadingAlert_content__2Nanl"};